let order_MenuCategoryList = require("../../templates/order/MenuCategoryList.handlebars");

let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");

let main = function () {
    return Backbone.View.extend({
        windowWidth: null,
        catViewWidth: null,
        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            'click .category .cell-wrapper': 'onClickCategory',
            'click .category .showCat': 'showAllCategory'
        },

        initialize: function () {
            $(window).on("resize", () => {
                this.windowWidth = null;
                this.catViewWidth = null;
                this.render();
            });
        },

        onPrev: function () {
            this.model.prev();
            if (this.model.getPageCollection()) {
                this.selectedCategory = this.model.getPageCollection().at(0);
            }
            this.render();
        },

        onNext: function () {
            this.model.next();
            if (this.model.getPageCollection()) {
                this.selectedCategory = this.model.getPageCollection().at(0);
            }
            this.render();
        },

        chooseCategory: function (cat) {
            var self = this;
            self.$('li').removeClass('active');
            self.$("li.cell-wrapper[data-id='" + cat.get("id") + "']").addClass("active");
            this.selectedCategory = this.model.getPageCollection().get(cat);
            this.trigger("selectCategory", this.selectedCategory);

        },
        onClickCategory: function (evt) {
            this.$('li').removeClass('active');
            $(evt.currentTarget).addClass('active');

            this.selectedCategory = this.model.getPageCollection().get($(evt.currentTarget).data('id'));

            this.trigger("selectCategory", this.selectedCategory);
        },

        showAllCategory: function (evt) {
            this.$('li').removeClass('active');
            $(evt.currentTarget).addClass('active');
            this.trigger("showAllCategory");
        },
        render: function () {
            let tabSize;
            if (this.windowWidth <= 0) {
                this.windowWidth = $(window).width();
            }
            if (this.catViewWidth <= 0) {
                this.catViewWidth = $(".catView").width();
            }

            let screenWidth = this.windowWidth;
            if (screenWidth > 768) {
                tabSize = 120;
            } else {
                tabSize = 130;
            }
            var pageSize = Math.floor((this.catViewWidth - tabSize - 13) / tabSize);
            this.model.set({pageSize: pageSize > 0 ? pageSize : 3});

            var cateCollection = this.model.getPageCollection().toJSON();
            var cateList = new Array();

            for(let obj of cateCollection){
                if(!obj.tempCategory){
                    cateList.push(obj);
                }
            }

            this.$el.html(order_MenuCategoryList({
                dataMenuCategories: cateList,
                maxPage: this.model.getMaxPage(),
                currentPage: this.model.get("offset") + 1,
                showPageInfo: this.model.showPage(),
                categorySize: this.model.get('collection').length
            }));

            // set the first element as selected category, if not select any category
            if (!this.selectedCategory) {
                if (this.model.getPageCollection()) {
                    this.selectedCategory = this.model.getPageCollection().at(0);
                }
            }

            // highlight the selected category
            if (this.selectedCategory) {
                this.$("li.cell-wrapper[data-id=" + this.selectedCategory.id + "]").addClass("active");
            }

            // trigger selectCategory event
            this.trigger("selectCategory", this.selectedCategory);

            return this;
        }

    });

};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/MenuCategoryListView.js